import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import OrderSortNameMap from "@/map/OrderSortNameMap";
import OrderSort from "@/scenes/OrderManagement/enum/OrderSort";
import { OrderSortPrioritizationRule } from "@/services/api/orderSortPrioritizationSetting";
import { UnorderedListOutlined } from "@ant-design/icons";
import { Alert, message, Modal } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import "./index.less";
import DraggableList from "@/components/DraggableList";

interface EditOrderSortModalProps extends InjectBaseModalProps {
    orderSortOptions: OrderSort[];
    onSave: (newData: OrderSortPrioritizationRule[]) => void;
}

const EditOrderSortModal: React.FC<EditOrderSortModalProps> = observer((props) => {
    const { open, onCancel, orderSortOptions, onSave } = props;
    const [data, setData] = useState<OrderSortPrioritizationRule[]>(
        orderSortOptions.map((orderSort, index) => ({ orderSort, index })),
    );

    async function handleSave() {
        onSave?.(data);

        message.success("保存成功");

        onCancel();
    }

    function handleDragEnd(newData: OrderSortPrioritizationRule[]) {
        setData(newData.map(({ orderSort }, index) => ({ orderSort, index })));
    }

    return (
        <Modal
            title="修改排序位置"
            open={open}
            onCancel={onCancel}
            okText="保存"
            destroyOnHidden
            width={600}
            className="edit-order-sort-modal"
            onOk={handleSave}
        >
            <Alert title="拖动表格可修改订单列表排序方式的位置" type="info" showIcon className="mb-4" />

            <div className="mt10">
                <div
                    className="flex"
                    style={{
                        padding: "12px 8px",
                        backgroundColor: "#fafafa",
                        border: "1px solid #f0f0f0",
                        borderTop: "none",
                    }}
                >
                    <div style={{ width: 410 }}>排序名称</div>
                    <div style={{ width: 140 }}>排序操作</div>
                </div>

                <DraggableList
                    direction="vertical"
                    onDragEnd={handleDragEnd}
                    data={data}
                    itemKey="orderSort"
                    renderItem={(item, { opacity, ref }) => {
                        return (
                            <div
                                ref={ref}
                                style={{ opacity, padding: "12px 8px", border: "1px solid #f0f0f0", borderTop: "none" }}
                                className="flex"
                            >
                                <div
                                    style={{
                                        width: 410,
                                    }}
                                >
                                    {OrderSortNameMap[item.orderSort]}
                                </div>
                                <div
                                    style={{
                                        width: 140,
                                    }}
                                >
                                    <UnorderedListOutlined
                                        style={{
                                            cursor: "move",
                                            color: "#1890ff",
                                            transition: "color 0.3s",
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    }}
                />
            </div>
        </Modal>
    );
});

export default EditOrderSortModal;
